module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bottle2-07dc798b0f2ab54aa43c37ea295e4c8e.svg";